import { refs, domReady, dispatchEvent } from '../modules/utils.js';

class NavMenuToggle extends HTMLElement {
  // static get observedAttributes() {
  //   return [];
  // }

  // attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  disconnectedCallback() {
    this.removeEventListener('pointerup', this.toggleListener);
    document.removeEventListener('navmenu:display', this.navMenuDisplayListener);
  }

  #listeners() {
    this.navMenuDisplayListener = this.navMenuDisplayListener.bind(this);

    this.addEventListener('pointerup', this.toggleListener);
    document.addEventListener('navmenu:display', this.navMenuDisplayListener);
  }

  toggleListener() {
    dispatchEvent('navmenutoggle:toggle');
  }

  navMenuDisplayListener({ detail }) {
    this.toggleAttribute('data-menu-display', !!detail.value);
  }
}

customElements.define('nav-menu-toggle', NavMenuToggle);
